import { action } from 'typesafe-actions'

import { Id, RequestClosingStatus } from 'src/types'

import { ClosingsActionTypes, ResponseDataClosings } from './types'

interface Options {
  page: number
  request_ids?: string[]
  filterStatus?: string[]
}

export const getClosings = (
  options: Options = { page: 1, request_ids: [], filterStatus: [] }
) => action(ClosingsActionTypes.GET_CLOSINGS, { options })

export const getClosingsSuccess = ({
  requests: list,
  total_results
}: ResponseDataClosings) =>
  action(ClosingsActionTypes.GET_CLOSINGS_SUCCESS, {
    list,
    total_results
  })

export const getClosingsFailure = (message: string) =>
  action(ClosingsActionTypes.GET_CLOSINGS_FAILURE, { message })

export const setClosingStatus = ({
  justification,
  request_id,
  request_closing_ids,
  status
}: {
  justification: string
  request_id: Id
  request_closing_ids: Id[]
  status: RequestClosingStatus
}) =>
  action(ClosingsActionTypes.SET_CLOSING_STATUS, {
    justification,
    request_id,
    request_closing_ids,
    status
  })

export const setClosingStatusSuccess = (message: string) =>
  action(ClosingsActionTypes.SET_CLOSING_STATUS_SUCCESS, { message })

export const setClosingStatusFailure = (message: string) =>
  action(ClosingsActionTypes.SET_CLOSING_STATUS_FAILURE, { message })
